export default {
  plantData: [],
  selectedYear: 0,
  selectedSeason: 0,
  isAllPlantings: false,
  searchText: '',
  currentPage: 1,
  orderName: 'created_at',
  sortAsc: false,
  fieldSearchText: '',
  fieldCurrentPage: 1,
  fieldOrderName: 'field_name',
  fieldSortAsc: true
}
